define('helperContent-customText',['helperContent-componentObject'], function(componentObject) {
    'use strict';

    function getText(component, textID) {    // Helper function
        var res = [],
            textObjects = [];
        if (component.length > 0) {

            //textObjects = component[0].content.items;
            for(var i = 0; i < component.length; i++){
                textObjects = textObjects.concat(component[i].content.items);
            }

            if (textObjects && textObjects.length) {
                var s = textObjects.length;
                while(s--) {
                    if (textObjects[s].content.id === textID && textObjects[s].content.text) {
                        res.push(textObjects[s].content.text);
                    }
                }
            }
        }
        return res;
    }
    function getCustomText(scope, textID, index, contentEntityId) {

        var res = [],
            textObjects,
            isCourseText = scope.course === undefined,
            pageEntity;

        if (isCourseText) { // is course UI text
            pageEntity = scope;
        } else { // is page specific text
            pageEntity = contentEntityId ? scope.getEntity(contentEntityId) : scope.getEntity(scope.contentEntityId());
        }

        // search short texts
        var shortTextObject = isCourseText ? componentObject.getComponentsByKind(pageEntity, 'ShortTexts') : componentObject.getComponentsOfPageByKind(pageEntity, 'ShortTexts');
        res = res.concat(getText(shortTextObject, textID));

        // search formatted texts
        var formattedTextObject = isCourseText ? componentObject.getComponentsByKind(pageEntity, 'FormattedTexts') : componentObject.getComponentsOfPageByKind(pageEntity, 'FormattedTexts');
        res = res.concat(getText(formattedTextObject, textID));

        // search text matrices
        var textMatricesObject = isCourseText ? componentObject.getComponentsByKind(pageEntity, 'TextMatrices') : componentObject.getComponentsOfPageByKind(pageEntity, 'TextMatrices');

        if (textMatricesObject.length > 0) {

            textObjects = textMatricesObject[0].content.items;
            if (textObjects && textObjects.length) {
                var m = textObjects.length;
                while(m--) {
                    if (textObjects[m].content.id === textID && textObjects[m].content.texts) {

                        if (index !== undefined) {

                            var r = textObjects[m].content.texts.length;
                            // loop through text matrix rows
                            while (r--) {
                                var c = textObjects[m].content.texts[r].length;
                                // loop through text matrix columns
                                while (c--) {
                                    if ((r === index[0] || index[0] === null) && (c === index[1] || index[1] === null)) {
                                        res.push(textObjects[m].content.texts[r][c]);
                                        res.reverse(); //re-arrange items
                                    }
                                }
                            }
                        } else {
                            res.push(textObjects[m].content.texts);
                        }
                    }
                }
            }
        }


        // search formatted texts
        var svgTextTextObjects = componentObject.getComponentsByKind(scope, 'SVGWithText');
        res = res.concat(getText(svgTextTextObjects, textID));

        return res;

    }

    return {
        getCustomText:getCustomText
    }
});

